<template>
  <div class="book-card book-image-wrapper dropup">
    <a :href="`/book-versions/${bookSlug}/${bookVersionId}`">
      <div class="responsive-aspect-ratio square-aspect-ratio" style="padding-top: 120%">
        <img :src="cover" style="border-radius: 10px" class="remove-black-line">
      </div>
    </a>
    <b-dropdown
      @shown="modalShown"
      id="dropdownAddTo"
      no-caret
      no-flip
      class="book-card-toggle-button"
      toggle-class="btn btn-white text-primary text-uppercase px-2 py-1">
      <template #button-content>
        <i class="fas fa-heart"></i>
      </template>
      <b-dropdown-item @click="openLibraryModal" :disabled="bookVersionStatus.in_library">Libreria</b-dropdown-item>
      <b-dropdown-item :href="`/commerce-books/add/${bookVersionId}`" :disabled="bookVersionStatus.in_commerce">Commercio</b-dropdown-item>
      <b-dropdown-item @click="openWishlistModal" :disabled="bookVersionStatus.in_wishlist">Wishlist</b-dropdown-item>
    </b-dropdown>
    <library-modal :book-version-id="bookVersionId" :book-title="bookTitle" ref="libraryModal" />
    <wishlist-modal :book-version-id="bookVersionId" :book-title="bookTitle" :cover="cover" :authors="authors" :subscribed="subscribed" ref="wishlistModal" />
  </div>
</template>

<script>
import LibraryModal from "./BookVersionCardComponents/LibraryModal.vue";
import GetBookVersionStatus from '../../graphql/GetBookVersionStatus.graphql';
import WishlistModal from "./BookVersionCardComponents/WishlistModal.vue";

export default {
  name: "BookVersionCard",
  components: {WishlistModal, LibraryModal},
  data() {
    return {
      load: false,
      bookVersionStatus: {
        in_wishlist: false,
        in_library: false,
        in_commerce: false,
      }
    }
  },
  props: {
    bookSlug: String,
    bookVersionId: Number,
    cover: String,
    bookTitle: String,
    subscribed: Boolean,
    authors: Array,
  },
  apollo: {
    bookVersionStatus: {
      query: GetBookVersionStatus,
      variables() {
        return {
          book_version_id: this.bookVersionId,
        }
      },
      skip() {
        return !this.load;
      },
    }
  },
  methods: {
    openLibraryModal() {
      this.$refs.libraryModal.open();
    },
    openWishlistModal() {
      this.$refs.wishlistModal.open();
    },
    modalShown() {
      this.load = true;
    }
  }
}
</script>

<style scoped>
  .book-card-toggle-button {
    position: absolute;
    bottom: 3%;
    right: 15%;
  }
</style>
